export default "__VITE_ASSET__CT6b5JQI__"